module.exports = __webpack_public_path__ + "static/img/2-12.999af08.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/2-12.png
// module id = 263
// module chunks = 0